(function () {
    'use strict';

    angular
        .module('documentManager')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('documentManager', {
                url: '/document-manager',
                views:{
                    'documentManagerView':{
                        templateUrl: 'document-manager/views/document-manager.tpl.html',
                        controller: 'DocumentManagerCtrl',
                        controllerAs: 'documentManager'
                    }
                }
            });
    }
}());
